import axios from 'axios';
import types from './mutations-types';

const actions = {
  async getAllActionGroups({ commit, state }, obj) {
    const response = await axios.get(
      `${process.env.API_ROOT}/filters/action-groups/${obj.companyId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          menuAside: obj.params.menuAside,
        },
      },
    );

    const favourite = response.data.find((group) => group.favourite === true);

    const dataGroup = await axios.get(
      `${process.env.API_ROOT}/action-group/favourite`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          menuAside: obj.params.menuAside,
        },
      },
    );

    if (favourite) {
      if (state.myMetric !== favourite.metric) {
        state.myMetric = favourite.metric;

        state.actionGroupData._id = favourite._id;
        state.actionGroupData.name = favourite.name;
      } else {
        state.actionGroupData = {
          _id: favourite._id,
          name: favourite.name,
        };
      }

      state.favouriteGroup._id = favourite._id;
      state.favouriteGroup.name = favourite.name;
      state.favouriteGroup.metric = favourite.metric;
    } else {
      // back-end valida se o usuario tem permissao aquele grupo de ação q esta favoritado
      if (dataGroup.data && dataGroup.data !== undefined) {
        state.actionGroupData = {
          _id: dataGroup.data._id,
          name: dataGroup.data.name,
        };

        state.myMetric = dataGroup.data.metric;
      } else {
        state.actionGroupData = {
          _id: null,
          name: 'Sem classificação',
        };
      }

      state.favouriteGroup = {
        _id: null,
        name: 'Sem classificação',
        metric: null,
      };
    }

    commit(types.SET_ALL_ACTION_GROUPS, response.data);
  },

  async getAllActions({ commit }, obj) {
    const response = await axios.get(
      `${process.env.API_ROOT}/filters/actions/${obj.companyId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: {
          ...obj.params,
        },
      },
    );

    commit(types.SET_ALL_ACTIONS, response.data);
  },

  async setActionList({ commit }, obj) {
    const resp = await axios.get(
      `${process.env.API_ROOT}/actions/${obj.companyId}`,
      {
        headers: { 'x-access-token': obj.token },
        params: { ...obj.query },
      },
    );

    commit(types.SET_ACTION_LIST, resp.data);
  },

  async removeAction({ commit }, obj) {
    await axios.delete(`${process.env.API_ROOT}/action/${obj.actionId}`, {
      headers: { 'x-access-token': obj.token },
    });
  },

  async setAction({ commit }, obj) {
    const action = await axios.get(`${process.env.API_ROOT}/action/${obj.id}`, {
      headers: {
        'x-access-token': obj.token,
      },
    });

    commit(types.SET_ACTION, action.data);
  },

  async setActionByObject({ commit }, obj) {
    commit(types.SET_ACTION, obj);
  },

  async setActionName({ commit, state }, value) {
    commit(types.SET_ACTION, {
      name: value,
      alertRules: {
        ...state.action.alertRules,
        title: `${value} - Tratativa Aguardando Retorno`,
      },
    });
  },

  async store({ commit }, obj) {
    const action = await axios.post(
      `${process.env.API_ROOT}/action/${obj.companyId}`,
      { ...obj.data },
      { headers: { 'x-access-token': obj.token } },
    );

    commit(types.SET_ACTION, action.data);
    return action.data;
  },

  async updateAction({ commit }, obj) {
    const action = await axios.put(
      `${process.env.API_ROOT}/action/${obj.id}`,
      { ...obj.data },
      { headers: { 'x-access-token': obj.token } },
    );

    commit(types.SET_ACTION, action.data);
  },

  async setSmsMessageLink({ commit }, value) {
    commit(types.SET_SMS_MESSAGE_LINK, value);
  },

  async setSmsMessage({ commit }, value) {
    commit(types.SET_SMS_MESSAGE, value);
  },

  async setSmsSubject({ commit }, value) {
    commit(types.SET_SMS_SUBJECT, value);
  },

  async setActionImage({ commit }, image) {
    if (image) {
      commit(types.SET_ACTION_UPLOADED_IMAGE, URL.createObjectURL(image.value));
    } else {
      commit(types.SET_ACTION_UPLOADED_IMAGE, null);
    }
  },

  async updateLogo({ commit }, obj) {
    const formData = new FormData();

    const myImage = await fetch(obj.uploadedImage);
    const blob = await myImage.blob();

    if (obj.uploadedImage) {
      formData.append('file', blob);
    }

    await axios.patch(
      `${process.env.API_ROOT}/action/import-logo/${obj.actionId}`,
      formData,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async updateLogoInvitationLetter({ commit }, obj) {
    const formData = new FormData();

    const myImage = await fetch(obj.uploadedImage);
    const blob = await myImage.blob();

    if (obj.uploadedImage) {
      formData.append('file', blob);
    }

    await axios.patch(
      `${process.env.API_ROOT}/action/import-logo/invitation-letter/${obj.actionId}`,
      formData,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async setReplys({ commit }, { detractors, neutral, promoters }) {
    commit(types.SET_ACTION, {
      reply: {
        detractors,
        neutral,
        promoters,
      },
    });
  },

  async setEmailSubject({ commit, state }, value) {
    commit(types.SET_ACTION, {
      email: {
        ...state.action.email,
        subject: value,
      },
    });
  },

  async setEmailFrom({ commit, state }, value) {
    commit(types.SET_ACTION, {
      email: {
        ...state.action.email,
        from: value,
      },
    });
  },

  async setChannel({ commit }, value) {
    commit(types.SET_ACTION, {
      channel: value,
    });
  },

  async setImageBody({ commit }, obj) {
    await axios.post(`${process.env.API_ROOT}/action/image-body`, {
      headers: {
        'x-access-token': obj.token,
      },
    });
  },

  async setMethodology({ commit }, value) {
    commit(types.SET_ACTION, {
      type: value,
    });
  },

  async setSmsConfig({ commit, state }, obj) {
    commit(types.SET_ACTION, {
      sms: {
        ...state.action.sms,
        ...obj,
      },
    });
  },

  async setScaleColorsAction({ commit, state }, value) {
    commit(types.SET_ACTION, {
      email: {
        ...state.action.email,
        template: {
          ...state.action.email.template,
          scale: value,
        },
      },
    });
  },

  async setBorderColorsAction({ commit, state }, value) {
    commit(types.SET_ACTION, {
      email: {
        ...state.action.email,
        template: {
          ...state.action.email.template,
          border: value,
        },
      },
    });
  },

  async setGradeColorsAction({ commit, state }, value) {
    commit(types.SET_ACTION, {
      email: {
        ...state.action.email,
        template: {
          ...state.action.email.template,
          grade: value,
        },
      },
    });
  },

  async setBodyEmail({ commit, state }) {
    commit(types.SET_ACTION, {
      email: {
        ...state.action.email,
      },
    });
  },

  async setIdTemplate({ commit, state }, value) {
    commit(types.SET_ACTION, {
      email: {
        ...state.action.email,
        template: {
          ...state.action.email.template,
          id: value,
        },
      },
    });
  },

  async setTestNpsReview({ commit }, value) {
    commit(types.SET_TEST_NPS_REVIEW, value);
  },

  async uploadFiles({ commit }, obj) {
    const formData = new FormData();
    formData.append('file', obj.file);
    formData.append('companyId', obj.companyId);
    formData.append('actionId', obj.actionId ? obj.actionId : '0001');

    const res = await axios.post(`${process.env.API_ROOT}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res;
  },

  async setAlertRuleId({ commit, state }, value) {
    commit(types.SET_ALERT_RULES, {
      ...state.action.alertRules,
      id: value,
    });
  },

  async setKeywordRuleId({ commit, state }, value) {
    commit(types.SET_KEYWORD_RULES, value);
  },

  async setAlertRuleExpire({ commit, state }, value) {
    commit(types.SET_ALERT_RULES, {
      ...state.action.alertRules,
      expire: value,
    });
  },

  async setQuarentineType({ commit, state }, value) {
    commit(types.SET_QUARENTINE, {
      ...state.action.quarentine,
      type: value,
    });
  },

  async setQuarentineDays({ commit, state }, value) {
    commit(types.SET_QUARENTINE, {
      ...state.action.quarentine,
      days: value,
    });
  },

  async setQuarentineDaysAnswer({ commit, state }, value) {
    commit(types.SET_QUARENTINE, {
      ...state.action.quarentine,
      daysAnswer: value,
    });
  },

  async setAlertRuleReminders({ commit, state }, value) {
    commit(types.SET_ALERT_RULES, {
      ...state.action.alertRules,
      reminders: value,
    });
  },

  async setAlertRuleTime({ commit, state }, value) {
    commit(types.SET_ALERT_RULES, {
      ...state.action.alertRules,
      time: value,
    });
  },

  async setAlertRuleInterval({ commit, state }, value) {
    commit(types.SET_ALERT_RULES, {
      ...state.action.alertRules,
      interval: value,
    });
  },

  async setAlertRuleTitle({ commit, state }, value) {
    commit(types.SET_ACTION, {
      ...state.action.alertRules,
      title: value,
    });
  },

  async setActionsIds({ commit, state }, value) {
    commit(types.SET_ACTIONS_IDS, {
      ...state.action.myActinsIds,
      value,
    });
  },

  async setMalling({ commit }, obj) {
    await axios.post(
      `${process.env.API_ROOT}/malling`,
      {
        ...obj.data,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async setColumns({ commit }, obj) {
    const list = await axios.post(
      `${process.env.API_ROOT}/file-columns`,
      {
        list: [...obj.data],
        companyId: obj.companyId,
        actionId: obj.actionId,
      },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    commit(types.SET_LIST_ID, list.data.listId);
  },

  async downloadFile(commit, obj) {
    axios({
      url: `${process.env.API_ROOT}/download/${obj.companyId}/${obj.actionId}`,
      method: 'POST',
      data: { columns: obj.columns },
      responseType: 'blob',
      headers: {
        'x-access-token': obj.token,
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'base_modelo.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  },

  async downloadQrcodeFile(commit, obj) {
    axios({
      url: `${process.env.API_ROOT}/qrcode/download/indicators`,
      method: 'POST',
      data: { columns: obj.columns },
      responseType: 'blob',
      headers: {
        'x-access-token': obj.token,
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'base_modelo.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  },

  async submit({ commit }, obj) {
    await axios.post(
      `${process.env.API_ROOT}/submit/${obj.companyId}/${obj.actionId}`,
      { ...obj.data },
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async submitImportFile({ commit }, obj) {
    const formData = new FormData();

    if (obj.data.date) {
      formData.set('date', obj.data.date);
    }

    if (obj.data.totalCustomers) {
      formData.set('totalCustomers', obj.data.totalCustomers);
    }

    formData.append('importFile', obj.importFile);

    await axios.post(
      `${process.env.API_ROOT}/submit/import-file/${obj.companyId}/${obj.actionId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': obj.token,
        },
      },
    );
  },

  async cleanAction({ commit }, obj) {
    commit(types.SET_ACTION, {
      ...obj.action,
    });
  },

  async getMallingInfo({ commit }, obj) {
    const resp = await axios.get(
      `${process.env.API_ROOT}/malling/${obj.companyId}/${obj.actionId}`,
      {
        companyId: obj.companyId,
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
    return resp;
  },

  async getNpsByAction({ commit }, obj) {
    const setNps = await axios.get(
      `${process.env.API_ROOT}/action/nps-by-action/${obj.companyId}/${obj.actionId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );

    commit(types.SET_NPS_BY_ACTION, setNps.data);
  },

  async deleteMallingInfo({ commit }, obj) {
    await axios.delete(
      `${process.env.API_ROOT}/malling/${obj.companyId}/${obj.actionId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },

  async setActionWordCloud({ commit }, obj) {
    try {
      const resp = await axios.get(
        `${process.env.API_ROOT}/wordcloud/action/${obj.actionId}`,
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
      commit(types.SET_ACTION_WORD_CLOUD, resp.data);
    } catch (err) {
      window.console.log(err);
    }
  },

  async setCloneAction({ commit }, obj) {
    try {
      // eslint-disable-next-line
      const resp = await axios.post(
        `${process.env.API_ROOT}/action/clone-action/${obj.id}`,
        {},
        { headers: { 'x-access-token': obj.token } },
      );
    } catch (error) {
      window.console.log(error);
    }
  },

  async setActionQuestion({ commit }, value) {
    commit(types.SET_ACTION_QUESTION, value);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/actions/actions.js